import { defineComponent, h } from 'vue';
import BaseComponent from './BaseComponentMixin.jsx';

import utils from '../../Shared/utils.jsx';
import { appSettings } from '@/Shared/appSettings';

export default defineComponent({
    name: 'Dummy',
    mixins: [BaseComponent],
    data: function () {
        return {
        }
    },
    computed: {
        thisstyle: function () {
            return {
                ...this.sizeStyle,
                ...utils.resolveStyleHints(this.styleHints, this),
                border: '1px solid silver',
                borderRadius: '8px',
            };
        }
    },
    methods: {
        preRenderComplete() {
            this.finishRenderHandler(this);
        },
    },
    render() {
        if (!this.todisplay) return null;

        try {
            // Match Vue2 default-unknown: only show unimplemented stubs when debug flag is on
            // (e.g. FacebookButton on Registration/CreateUser — no runtime control in either portal).
            if (!appSettings.ShowNotImplemented)
                return null;

            return this.isvisible ? (
                <div style={this.thisstyle} class={{ ['c-' + (this.type || 'unknown')] : true, [`c-name-${this.name || 'unnamed'}`]: true }}>
                    {this.name || ''}|{this.type || this.controlData?.Name || this.$attrs.schema?.type || 'Unknown'}
                </div>
            ) : null;
        } catch (e) {
            utils.error('Dummy Render failed', e);
            return <div>Dummy Failed to Render {e}</div>;
        }
    }
});